import React, { useEffect, useState, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../style/custommillingHubdashboard.css";
import DataTable, { TableColumn } from "react-data-table-component";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SearchBox from "../CentralHub/Designer/SearchBox";
import SortFilter from "../CentralHub/Designer/SortFilter";
import { getAuthToken } from "../../utils/auth";
import { DeliveryOrderRow } from "../../components/Deliverypartner/DeliveryOrderRow";
import "../../style/deliverypartnertable.css";
import { apiAxios } from "../../utils/apiAxios";
import { useRef } from "react";
import AlertSoundManager from "../../utils/AlertSoundManager";
const DeliverypartnerDashboard: React.FC = () => {
  const [orders, setOrders] = useState<DeliveryOrderRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [selectedMobile, setSelectedMobile] = useState("");
  const [selectedCaseId, setSelectedCaseId] = useState<number | null>(null);
  const [otpSent, setOtpSent] = useState(false);
  const [otpTimer, setOtpTimer] = useState(0);
  const [showResend, setShowResend] = useState(false);
  const [sendingOtp, setSendingOtp] = useState(false);
  const [resendCount, setResendCount] = useState(0);
  const [modalMode, setModalMode] = useState<"display" | "verify" | null>(null);
  const [fetchedOtp, setFetchedOtp] = useState("");
  const [searchText, setSearchText] = useState("");
  const [showDeliveredModal, setShowDeliveredModal] = useState(false);
  const [deliveredData, setDeliveredData] = useState<any>(null);
  const [audioEnabled, setAudioEnabled] = useState(false);

  const [hasAssignedOrder, setHasAssignedOrder] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const enableAudio = async () => {
    try {
      await AlertSoundManager.unlock();

      setAudioEnabled(true);

      toast.success("Delivery sound alerts enabled.");
    } catch {
      toast.error("Please allow sound playback.");
    }
  };




  const fetchDeliveryOtp = async (caseId: number) => {
    try {
      setLoading(true);
      const token = getAuthToken();

      const res = await apiAxios.get(
        `${API_BASE_URL}/DeliveryPartner/GetDeliveryOtp?caseId=${caseId}`,

      );

      if (res.data?.isSuccess) {
        setFetchedOtp(res.data.singleData);
        setModalMode("display");
      } else {
        toast.error(res.data?.status || "OTP not found");
      }
    } catch (error) {
      console.error("Error fetching OTP:", error);
      toast.error("Failed to fetch OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleStatusClick = (row: DeliveryOrderRow) => {
    if (row.orderState === "READY_FOR_DELIVERY") {
      fetchDeliveryOtp(row.caseID);
    } else if (row.orderState === "OUT_FOR_DELIVERY" && row.status != "Ready for Dispatch") {
      setSelectedCaseId(row.caseID);
      setSelectedMobile(row.mobile);
      setModalMode("verify");
    }
    else if (row.status?.toLowerCase() === "done") {
      openDeliveredPopup(row);
    }

    else if (row.status == "Ready for Dispatch") {
      toast.error("Please collect all clubbed orders")
    }
  };

  const closeModal = () => {
    setModalMode(null);
    setOtp("");
    setOtpSent(false);
    setFetchedOtp("");
    setShowResend(false);
    setOtpTimer(0);
  };


  const openDeliveredPopup = (row: DeliveryOrderRow) => {
    setDeliveredData({
      clinicName: row.clinicDetails,
      millingHub: row.millingHub,

      pickedTime: formatDateTime(row.pickedTime),

      deliveredOn: formatDateTime(row.deliveredTime),

      duration: formatDeliveryTime(row.deliveryMinutes),
      delay: formatDeliveryTime(row.delayMinutes)
    });

    setShowDeliveredModal(true);
  };

  const fetchDeliveryOrders = async () => {
    try {
      setLoading(true);

      const token = getAuthToken();

      const res = await apiAxios.get(
        `${API_BASE_URL}/DeliveryPartner/GetDeliveryOrders`,

      );


      const apiData = res.data.singleData || [];
      console.log(apiData, "api data here")
      const mappedData: DeliveryOrderRow[] = apiData.map((item: any) => ({
        orderID: item.orderID,
        isClubbed: item.isClubbed,
        clubGroupID: item.clubGroupID,
        clinicName: item.clinicName,
        deliveryType: item.orderTypeName,
        millingHub: item.millingHub,
        millingHubAddress: item.millingHubAddress,
        clinicDetails: item.clinicDetails,
        clinicAddress: item.clinicAddress,
        mobile: item.deliveryContact,
        orderState: item.orderState,
        status: item.deliveryTag,
        statusID: 0,
        caseID: item.caseID,
        expectedDeliveryTime: formatDate(item.createdDate),
        deliveredOn: item.deliveredOn,
        deliveryDuration: item.deliveryDuration,
        assignedOn: item.assignedOn,
        priority: "",
        distance: "",
        pickedTime: item.pickedTime,
        deliveredTime: item.deliveredTime,
        deliveryMinutes: item.deliveryMinutes,
        delayMinutes: item.delayMinutes,
        clinicLongitude: item.clinicLongitude,
        clinicLatitude: item.clinicLatitude,
        millingHubLatitude: item.millingHubLatitude,
        millingHubLongitude: item.millingHubLongitude
      }));


      setOrders(mappedData);

    } catch (error) {
      console.error("API Error:", error);
      toast.error("Failed to load delivery orders");
    } finally {
      setLoading(false);
    }
  };


  const formatDateTime = (dateString?: string) => {
    if (!dateString) return "N/A";

    return new Date(dateString).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true
    });
  };
  const formatDeliveryTime = (minutes?: number) => {
    if (minutes === null || minutes === undefined) return "N/A";

    if (minutes < 60) {
      return `${minutes} Min`;
    }

    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;

    return `${hrs} Hr ${mins} Min`;
  };

  useEffect(() => {
    let interval: any;

    if (otpTimer > 0) {
      interval = setInterval(() => {
        setOtpTimer((prev) => prev - 1);
      }, 1000);
    }
    else if (otpTimer === 0 && otpSent) {
      setShowResend(true);
    }

    return () => clearInterval(interval);

  }, [otpTimer, otpSent]);




  const sendOtp = async () => {
    try {
      const token = getAuthToken();
      setSendingOtp(true);

      await apiAxios.post(
        `${API_BASE_URL}/DeliveryPartner/SendOtpInClinic?caseId=${selectedCaseId}&mobile=${selectedMobile}`,
        {},

      );

      toast.success("OTP Sent Successfully");

      setOtpSent(true);
      setResendCount(0);
      setOtpTimer(60);
      setShowResend(false);

    } catch (error) {
      toast.error("Failed to send OTP");
    } finally {
      setSendingOtp(false);
    }
  };

  const resendOtp = async () => {
    try {
      const token = getAuthToken();

      await apiAxios.post(
        `${API_BASE_URL}/DeliveryPartner/ResendClinicOtp?caseId=${selectedCaseId}`,
        {},

      );

      const newCount = resendCount + 1;
      setResendCount(newCount);
      setOtp("");
      toast.success("OTP Resent Successfully");

      if (newCount >= 3) {
        setOtpTimer(1800);
      } else {
        setOtpTimer(60);
      }

      setShowResend(false);

    } catch (error) {
      toast.error("Failed to resend OTP");
    }
  };
  const filteredData = useMemo(() => {
    if (!orders) return [];

    return orders.filter((item) =>
      Object.values(item).some((val) =>
        String(val).toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }, [orders, searchText]);

  useEffect(() => {
    const assigned = filteredData.some(
      x => x.status?.toLowerCase() === "assigned"
    );

    setHasAssignedOrder(assigned);
  }, [filteredData]);

  useEffect(() => {
    if (!audioEnabled) return;

    if (hasAssignedOrder) {
      AlertSoundManager.play();
    } else {
      AlertSoundManager.stop();
    }
  }, [hasAssignedOrder, audioEnabled]);

  // ---------- CLUBBED GROUP HELPERS (added to fix identical-looking clubbed rows) ----------
  // Formal, muted corporate palette — alternates between two professional tones
  // so consecutive packets are distinguishable without looking playful.
  const CLUB_GROUP_PALETTE = [
    { bg: "#EFF3F8", border: "#334E68" }, // slate navy
    { bg: "#F4F1EA", border: "#8A6D3B" }, // muted bronze/tan
  ];

  const clubGroupInfo = useMemo(() => {
    const countMap: Record<string, number> = {};
    const colorMap: Record<string, { bg: string; border: string }> = {};
    const packetNumberMap: Record<string, number> = {};
    let paletteIndex = 0;

    filteredData.forEach((row) => {
      if (row.isClubbed && row.clubGroupID) {
        countMap[row.clubGroupID] = (countMap[row.clubGroupID] || 0) + 1;

        if (!colorMap[row.clubGroupID]) {
          colorMap[row.clubGroupID] =
            CLUB_GROUP_PALETTE[paletteIndex % CLUB_GROUP_PALETTE.length];
          packetNumberMap[row.clubGroupID] = paletteIndex + 1;
          paletteIndex++;
        }
      }
    });

    return { countMap, colorMap, packetNumberMap };
  }, [filteredData]);

  const getGroupBoundary = (row: DeliveryOrderRow) => {
    if (!row.isClubbed || !row.clubGroupID) {
      return { isFirst: false, isLast: false };
    }

    const idx = filteredData.findIndex(
      (r) => r.orderID === row.orderID && r.caseID === row.caseID
    );

    const prevRow = filteredData[idx - 1];
    const nextRow = filteredData[idx + 1];

    const isFirst = !prevRow || prevRow.clubGroupID !== row.clubGroupID;
    const isLast = !nextRow || nextRow.clubGroupID !== row.clubGroupID;

    return { isFirst, isLast };
  };
  // ---------- END CLUBBED GROUP HELPERS ----------

  const verifyOtp = async () => {
    try {
      const token = getAuthToken();

      await apiAxios.post(
        `${API_BASE_URL}/DeliveryPartner/VerifyClinicDeliveryOtp?caseId=${selectedCaseId}&mobile=${selectedMobile}&otp=${otp}`,
        {},

      );

      toast.success("OTP Verified Successfully");

      setShowOtpModal(false);
      setOtp("");
      closeModal();
      fetchDeliveryOrders();

    } catch (error) {
      toast.error("OTP verification failed");
    }
  };

  const formatTimer = (seconds: any) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, "0")}`;
  };

  useEffect(() => {
    // Initial load
    fetchDeliveryOrders();

    // Auto refresh every 30 sec
    const interval = setInterval(() => {

      // ❗ Check if modal is open (VERY IMPORTANT)
      const isModalOpen = modalMode !== null;

      if (!isModalOpen && !searchText) {
        fetchDeliveryOrders();
      }
    }, 30000);

    return () => clearInterval(interval);

  }, [modalMode]);

  // const getStatusStyle = (status: string) => {
  //   switch (status?.toLowerCase()) {
  //     case "assigned":
  //       return { background: "#2563eb", color: "#fff" };

  //     case "accepted":
  //       return { background: "#0d9488", color: "#fff" };

  //     case "delivered":
  //       return { background: "#16a34a", color: "#fff" };

  //     default:
  //       return { background: "#6b7280", color: "#fff" };
  //   }
  // };

  const normalizeStatus = (status: string = "") =>
    status
      .toLowerCase()
      .trim()
      .replace(/[\s-]+/g, "_");

  const getStatusStyle = (status: string) => {
    switch (normalizeStatus(status)) {
      case "assigned":
        return { background: "#e0f2fe", color: "#0369a1" };

      case "accepted":
        return { background: "#fef3c7", color: "#92400e" };

      case "delivered":
        return { background: "#d1fae5", color: "#065f46" };

      case "done":
        return { background: "#16a34a", color: "#fff" };

      case "pending":
        return { background: "#f3f4f6", color: "#374151" };

      case "cancelled":
        return { background: "#fecaca", color: "#b91c1c" };

      case "out_for_delivery":
        return { background: "#3B82F6", color: "#fff" };

      case "delay_report":
        return { background: "#fee2e2", color: "#991b1b" };

      case "under_review":
        return { background: "#e0e7ff", color: "#3730a3" };

      default:
        return { background: "#6b7280", color: "#fff" };
    }
  };
  const openDirectionsFromCurrentLocation = (lat: number, lng: number) => {
    if (!lat || !lng) {
      alert("Destination not available");
      return;
    }

    if (!navigator.geolocation) {
      alert("Geolocation not supported");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const currentLat = position.coords.latitude;
        const currentLng = position.coords.longitude;

        window.open(
          `https://www.google.com/maps/dir/?api=1&origin=${currentLat},${currentLng}&destination=${lat},${lng}&travelmode=driving`,
          "_blank"
        );
      },
      (error) => {
        alert("Unable to fetch current location");
        console.error(error);
      }
    );
  };
  const columns: TableColumn<DeliveryOrderRow>[] = [
    {
      name: "Order",
      cell: (row) => (
        <div>
          <div>{row.orderID}</div>

          {row.isClubbed && row.clubGroupID && (
            <span
              className="badge mt-1"
              style={{
                fontSize: "10px",
                fontWeight: 600,
                color: clubGroupInfo.colorMap[row.clubGroupID]?.border || "#334E68",
                backgroundColor: "#fff",
                border: `1px solid ${clubGroupInfo.colorMap[row.clubGroupID]?.border || "#334E68"}`,
              }}
            >
              Packet {clubGroupInfo.packetNumberMap[row.clubGroupID]}
              {clubGroupInfo.countMap[row.clubGroupID]
                ? ` · ${clubGroupInfo.countMap[row.clubGroupID]} Orders`
                : ""}
            </span>
          )}
        </div>
      ),
      sortable: true,
      style: {
        textAlign: "center",
      },


    },
    {
      name: "Milling Hub",
      cell: (row) => (
        <div className="name-cell">
          <div className="name">{row.millingHub}</div>
          <div
            className="link-text"
            onClick={() =>
              openDirectionsFromCurrentLocation(
                row.millingHubLatitude,
                row.millingHubLongitude
              )
            }
          >
            <i className="bi bi-geo-alt-fill me-1"></i>
            {row.millingHubAddress}
          </div>
        </div>
      ),
      style: {
        minWidth: "220px"
      }
    },

    {
      name: "Clinic",
      cell: (row) => (
        <div className="name-cell">
          <div className="name">{row.clinicDetails}</div>
          <div
            className="link-text"
            onClick={() =>
              openDirectionsFromCurrentLocation(
                row.clinicLatitude,
                row.clinicLongitude
              )
            }
          >
            <i className="bi bi-geo-alt-fill me-1"></i>
            {row.clinicAddress}
          </div>
        </div>
      ),

      center: true,
      width: "200px",
    },



    {
      name: "DeliveryType",
      cell: (row) => (
        <div className="name-cell highlight">
          {/* <div className="name">{row.mobile}</div> */}
          <div className="sub-text">{row.deliveryType}</div>
        </div>
      ),
      width: "170px",
      center: true,
    },
    // {
    //   name: "Distance",
    //   cell: (row) => (
    //     <div className="time-box">
    //       <span>{row.distance}</span>
    //     </div>
    //   ),
    //   center: true,
    //   width: "150px"
    // },

    {
      name: "Expected Delivery",
      center: true,
      cell: (row) => (
        <div className="time-box">
          <span>{row.expectedDeliveryTime}</span>
        </div>
      ),

      width: "170px"
    },

    {
      name: "Status",
      center: true,
      width: "170px",

      cell: (row) => {
        const isActive = row.status?.toLowerCase() !== "delivered";

        return (
          <div className="d-flex justify-content-center w-100">
            <span
              className={`status-pill ${isActive ? "status-blink" : ""}`}
              style={getStatusStyle(row.status)}
              onClick={() => handleStatusClick(row)}
            >
              {row.status || "-"}
            </span>
          </div>
        );
      },
    }
  ];
  const conditionalRowStyles = [
    {
      when: (row: DeliveryOrderRow) => !!row.isClubbed,
      style: (row: DeliveryOrderRow) => {
        const colors =
          (row.clubGroupID && clubGroupInfo.colorMap[row.clubGroupID]) ||
          CLUB_GROUP_PALETTE[0];

        const { isFirst, isLast } = getGroupBoundary(row);

        return {
          backgroundColor: colors.bg,
          borderLeft: `4px solid ${colors.border}`,
          borderTop: isFirst ? `1px solid ${colors.border}` : "none",
          borderBottom: isLast ? `1px solid ${colors.border}` : "none",
        };
      },
    },
  ];
  return (
    <>
      {!audioEnabled && (
        <div className="audio-permission-overlay">
          <div className="audio-permission-box">
            <div className="audio-icon">🔔</div>

            <p>
              Click below to allow sound alerts whenever a
              <strong> New Delivery is assigned</strong>.
            </p>

            <button
              className="btn btn-danger enable-sound-btn"
              onClick={enableAudio}
            >
              Enable Sound Alerts
            </button>
          </div>
        </div>
      )}
      <div className="container-fluid p-0">
        <div className="row mt-4">
          <div className="col-md-12">
            <div className="shadow-container rounded p-3 mt-4">
              <div className="search-button-section mb-3">
                <SearchBox value={searchText} onChange={setSearchText} />
                <SortFilter />
              </div>

              <DataTable
                columns={columns}
                //data={orders}
                data={filteredData}
                conditionalRowStyles={conditionalRowStyles}
                progressPending={loading}
                pagination
                highlightOnHover
                pointerOnHover
                noDataComponent="No delivery orders found"
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 30]}
              />

              {/* OTP Modal */}
              {modalMode && (
                <>
                  <div className="premium-backdrop"></div>

                  <div className="modal show d-block premium-modal-wrapper">
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content premium-modal">

                        {/* HEADER */}
                        <div className="modal-header premium-header">
                          <h5 className="modal-title">
                            {modalMode === "display" ? "Delivery OTP" : "Verify Delivery OTP"}
                          </h5>

                          <button type="button" onClick={closeModal} className="btn-close custom-close-btn" aria-label="Close"><i className="bi bi-x customcross"></i></button>
                        </div>

                        {/* BODY */}
                        <div className="modal-body premium-body">

                          {modalMode === "display" ? (
                            <div className="otp-display-box text-center">
                              <h1 className="otp-text">{fetchedOtp}</h1>
                              <p className="otp-subtext">
                                Share this OTP with the clinic
                              </p>
                            </div>
                          ) : (
                            <>
                              {!otpSent ? (
                                <div className="text-center">
                                  <button
                                    className="btn btn-primary premium-btn"
                                    disabled={sendingOtp}
                                    onClick={sendOtp}
                                  >
                                    Send OTP
                                  </button>
                                </div>
                              ) : (
                                <>
                                  <div className="mb-3">
                                    <div className="fw-semibold text-center mb-3">Enter OTP</div>
                                    <div className="otp-container">
                                      {[...Array(6)].map((_, index) => (
                                        <input
                                          key={index}
                                          type="text"
                                          maxLength={1}
                                          className="otp-box"
                                          value={otp[index] || ""}
                                          onChange={(e) => {
                                            const val = e.target.value.replace(/[^0-9]/g, "");
                                            const newOtp = otp.split("");
                                            newOtp[index] = val;
                                            setOtp(newOtp.join(""));

                                            // auto focus next
                                            if (val && e.target.nextSibling) {
                                              (e.target.nextSibling as HTMLInputElement).focus();
                                            }
                                          }}
                                          onKeyDown={(e) => {
                                            // backspace move back
                                            if (e.key === "Backspace" && !otp[index] && e.currentTarget.previousSibling) {
                                              (e.currentTarget.previousSibling as HTMLInputElement).focus();
                                            }
                                          }}
                                        />
                                      ))}
                                    </div>
                                  </div>

                                  {otpTimer > 0 && (
                                    <p className="timer-text text-center">
                                      Resend in {formatTimer(otpTimer)}
                                    </p>
                                  )}

                                  {showResend && (
                                    <div className="text-center">
                                      <button
                                        className="btn btn-warning premium-btn-warning mt-3"
                                        onClick={resendOtp}
                                      >
                                        Resend OTP
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </>
                          )}



                          {/* FOOTER */}
                          {modalMode === "verify" && otpSent && !showResend && (
                            <div className="btn-section-center text-center  pb-3 mb-2">
                              <button
                                className="btn btn-primary "
                                onClick={verifyOtp}
                              >
                                Verify OTP
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}


              {showDeliveredModal && (
                <>
                  <div className="premium-backdrop"></div>

                  <div className="modal show d-block ">
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content">

                        <div className="modal-header premium-header">
                          <h5 className="modal-title">Delivery Details</h5>

                          <button type="button" onClick={() => setShowDeliveredModal(false)} className="btn-close custom-close-btn" aria-label="Close"><i className="bi bi-x customcross"></i></button>
                        </div>

                        <div className="modal-body">
                          <ul className="list-unstyled maindelivery-list">

                            <li className="delivery-detail-list">
                              <strong className="label-text">Milling Name:</strong>
                              <span className="value-text">{deliveredData?.millingHub}</span>
                            </li>

                            <li className="delivery-detail-list">
                              <strong className="label-text">Picked Time:</strong>
                              <span className="value-text">{deliveredData?.pickedTime}</span>
                            </li>

                            <li className="delivery-detail-list">
                              <strong className="label-text">Clinic Name:</strong>
                              <span className="value-text">{deliveredData?.clinicName}</span>
                            </li>

                            <li className="delivery-detail-list">
                              <strong className="label-text">Delivered On:</strong>
                              <span className="value-text">{deliveredData?.deliveredOn}</span>
                            </li>

                            <li className="delivery-detail-list">
                              <strong className="label-text">Delivery Duration:</strong>
                              <span className="value-text">{deliveredData?.duration}</span>
                            </li>

                            <li className="delivery-detail-list">
                              <strong className="label-text">Delivery Delay:</strong>
                              <span className="value-text text-danger">
                                {deliveredData?.delay}
                              </span>
                            </li>

                          </ul>
                        </div>

                        <div className="premium-footer">
                          <button
                            className="btn btn-primary px-3"
                            onClick={() => setShowDeliveredModal(false)}
                          >
                            OK
                          </button>
                        </div>

                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );

};


export default DeliverypartnerDashboard;
